import BaseModel from "./BaseModel"

export default class BidModel extends BaseModel {
    get schema() {
        return {
            user_id: 0,
            service_type: null,
            type: 1
        }
    }

    prepareCreate() {
        this.baseClear()

        return this
    }

    prepareUpdate() {
        this.baseClear()

        return this
    }
}
